import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectCompletionService } from '../../../../../shared/API-Service/services/project-completion.service';
import Swal from 'sweetalert2';
import {ProjectAccomplishment} from "../../../../../shared/Models/ProjectAccomplishment";
import { environment } from 'src/environments/environment.prod';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';
import { ProjectsService } from '../../../../../shared/API-Service/services/projects.service';

@Component({
  selector: 'app-insert-project-accomplishment',
  templateUrl: './insert-project-accomplishment.component.html',
  styleUrls: ['./insert-project-accomplishment.component.css']
})
export class InsertProjectAccomplishmentComponent implements OnInit {
  id: string;
  update: boolean;
  insertForm: FormGroup;
  completionprojectformdata: FormData;
  Projects = new ProjectAccomplishment();
  imageproject:any
  Image: any;
  ProjectAccomplishment: any;
  CreatProjectForm: any = new FormData();
  Governates:any[]=[];
  dropdownSettings: any = {};
  selectedItemsGovernates: any[]=[]
  Projectid: string;
  Project: any;
  ProjectName: any;
  GovernatesIds: any[]=[];
  projectcompletionid: any;
  GovernatesForEdit: any[]=[];
  constructor(private GovernorateService:GovernorateService,private ProjectCompletionService:ProjectCompletionService,private ProjectsService:ProjectsService,private _formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute) {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'title',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
   }

  
  
  ngOnInit(): void {
    this.GetGovernorate();
    this.Projectid = this.route.snapshot.paramMap.get("id");
    this.initForm();
    this.imageproject="../../../../../assets/images/upload.png"
//  console.log(this.route.snapshot.paramMap.get("projectcompletionid"))

    if (this.route.snapshot.paramMap.get("id")) {

      this.Projectid =this.route.snapshot.paramMap.get("id")
      this.ProjectsService.GetProjectsByid(this.Projectid).subscribe(async (res:any)=>{
        console.log(res.data);
      this.ProjectName=res.data.title;
if(this.route.snapshot.paramMap.get("projectcompletionid")){
  this.projectcompletionid=this.route.snapshot.paramMap.get("projectcompletionid");
  this.ProjectCompletionService.GetProjectCompletionByid(this.projectcompletionid).subscribe(async (res:any)=>{
    this.ProjectAccomplishment=  await res.data;
    
  this.ProjectAccomplishment.governorates.forEach(element => {
    this.GovernatesForEdit.push(element);
  });

    this.selectedItemsGovernates=this.GovernatesForEdit;
    this.checkEdit(res.data);
  })
 this.update = true;
}

      })
    } 
    else {
      this.initForm()
       this.update = false;
    }
  }
  GetGovernorate(){
    this.GovernorateService.GetGovernorate().subscribe(res=>{
      this.Governates=res.data;
    })
  }
  initForm() {
    this.insertForm = this._formBuilder.group({
      
      title: ['', Validators.required],
      description: ['', Validators.required],
      completionPercent: ['', Validators.required],
      projectcompletionimage: ['', Validators.required],
    });
  }
  checkEdit(data) {
    if (data != null) {
      this.insertForm = this._formBuilder.group({
        title: [data.title, Validators.required],
        description: [data.description, Validators.required], 
        completionPercent: [data.completionPercent, Validators.required], 
     
        projectcompletionimage : [data.projectcompletionimage]
      });
      if( data.image != null){
        
        this.imageproject = `https://alnada-ekramapi.azurewebsites.net/${data.image}`;
      }
      this.update = true;
    
    } else {
      console.log(`not found on data`);
      // this.initiate();
    }
}
  get fc() {
    return this.insertForm.controls;
  }
 projectformdata(){
    this.completionprojectformdata = new FormData();
    this.completionprojectformdata.append("Title", this.insertForm.value.title);
    this.completionprojectformdata.append("Description", this.insertForm.value.description);
    this.completionprojectformdata.append("CompletionPercent", this.insertForm.value.completionPercent);
    debugger
    this.selectedItemsGovernates.forEach(element => {
      this.completionprojectformdata.append("GovernoratesIds", element.id);   
      });
    this.completionprojectformdata.append("ProjectCompletionImage", this.Image);
    this.completionprojectformdata.append("ProjectId", this.Projectid);
  }
  
  Submit(){
   

    if (this.insertForm.status == "VALID") {
      if (this.update == true) {
        this.UpdateProjectcompletion();
      } else {
        this.InsertProjectcompletion();
      }
    }
     else {
      this.insertForm.markAllAsTouched();
    }

  }
  UpdateProjectcompletion(){
    this.projectformdata();
    this.completionprojectformdata.append("Id", this.projectcompletionid);
    this.ProjectCompletionService.UpdateProjectCompletion(this.completionprojectformdata).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم التعديل بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.router.navigate(['/content/admin/ViewProjectCompletion',this.Projectid]);
    },
      (err) => {
        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
  
      );
  }
  
  InsertProjectcompletion(){
    this.projectformdata();
    this.ProjectCompletionService.CreateProjectCompletion(this.completionprojectformdata).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      // this.router.navigateByUrl("content/admin/ViewProjectCompletion");
      this.router.navigate(['/content/admin/ViewProjectCompletion',this.Projectid]);
    },
      (err) => {
        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
            );
  }
  OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageproject = reader.result as string;
        // this.logoForm?.set("image", this.Image);
      };
    }
  }
}

function removeItem(item: any, selectedItemsGovernates: any[]) {
  throw new Error('Function not implemented.');
}

